const {
  VUE_APP_BASE_API,
  VUE_APP_BASE_API_JAVA,
  VUE_APP_BASE_LOG_URL,
  VUE_APP_STAR,
  VUE_APP_STAR_PLAN,
  VUE_APP_BASE_ACT_URL,
  VUE_APP_BASE_LOGIN_URL,
} = process.env;

const baseURL = VUE_APP_BASE_API || '';
const base_java_url = VUE_APP_BASE_API_JAVA || '';
const base_log_url = VUE_APP_BASE_LOG_URL || '';
const base_star_url = VUE_APP_STAR || '';
const base_star_plan_url = VUE_APP_STAR_PLAN || '';
const base_act_url = VUE_APP_BASE_ACT_URL || '';
const base_login_url = VUE_APP_BASE_LOGIN_URL || '';
export {
  baseURL,
  base_java_url,
  base_log_url,
  base_star_url,
  base_star_plan_url,
  base_act_url,
  base_login_url,
};
